import { Topic } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { GetMainSectionFn } from '../custom-topic-routes'

const bannerDesktopX2 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-lg@2x.jpg')
const bannerDesktopX1 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-lg@1x.jpg')
const bannerTabletX2 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-md@2x.jpg')
const bannerTabletX1 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-md@1x.jpg')
const bannerMobileX2 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-sm@2x.jpg')
const bannerMobileX1 = require<string>('./assets/the-debrief/2025-The-Debrief-Feature-Banner-sm@1x.jpg')

const getTopicContent = (
    offsetNum: number,
    topic: Topic | undefined,
    isFirst: boolean,
) => {
    const topicId = topic ? topic.id : 'business/the-debrief'

    return layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: {
                initial: 'visible',
                xs: 'visible',
                sm: 'visible',
                md: 'visible',
            },
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: isFirst
                ? {
                      heading: 'The Latest from The Debrief',
                      headingUrl: `/${topicId}`,
                  }
                : undefined,

            dataDefinitionArgs: {
                type: 'listing',
                topics: [topicId],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageOffset: offsetNum,
                    pageSize: 8,
                },
            },
            loadMoreEnabled: !isFirst,
        },
    })
}

export const getBusinessDebriefRouteSection: GetMainSectionFn = (
    sectionBuilder,
    _,
    topic,
) => [
    layout.component({
        type: 'image-banner',
        props: {
            defaultSrc: bannerDesktopX2,
            verticalGutters: ['unset', 'md'],
            altText: `${topic?.seoTitle || 'The Debrief'} Banner`,
            sources: [
                {
                    breakpoint: 'md',
                    src: [
                        {
                            src: bannerDesktopX2,
                            density: '2x',
                        },
                        {
                            src: bannerDesktopX1,
                            density: '1x',
                        },
                    ],
                },
                {
                    breakpoint: 'xs',
                    src: [
                        {
                            src: bannerTabletX2,
                            density: '2x',
                        },
                        {
                            src: bannerTabletX1,
                            density: '1x',
                        },
                    ],
                },
                {
                    src: [
                        {
                            src: bannerMobileX2,
                            density: '2x',
                        },
                        {
                            src: bannerMobileX1,
                            density: '1x',
                        },
                    ],
                },
            ],
        },
    }),
    ...sectionBuilder.getCuratedSection(undefined, true),
    ...billboardLeaderboardMrec('one'),
    // Now a sub heading / another few articles
    getTopicContent(0, topic, true),
    ...billboardLeaderboardMrec('two'),
    getTopicContent(8, topic, false),
    ...billboardLeaderboardMrec('three'),
]
